import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

const Notifications = () => {
    return <ToastContainer data-testid='Notifications'  limit={2} theme="light" closeOnClick newestOnTop position="top-right" autoClose={2000} />
}

export default Notifications
